export default __webpack_public_path__ + "static/media/no-image.6a58e989.jpg";